<template>
<div class="flex flex-col">
  <!-- 3 column wrapper -->
  <div class="w-full lg:flex">
    <!-- Left sidebar & main wrapper -->

    <div class="flex-auto mb-4">
      <range-selector />
      <div class="flex-shrink-0 w-full md:w-96 xl:w-96 lg:w-96 border border-gray-200 shadow">
        <div class="flex items-center justify-between">
            <side-panel :root="'device'" class="w-full"/>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-4 sm:ml-1 xl:ml-4 lg:ml-4">
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <!-- Card -->
        <div class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 col-span-2">
          <div class="px-4 py-4 sm:px-6">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <nav class="flex" aria-label="Breadcrumb">
              <ol role="list" class="flex items-center space-x-4">
                <li v-if="currentDevice.plant !== ''">
                  <div>
                    <p href="#" class="ml-2 text-sm font-medium text-gray-500 hover:text-gray-700">{{currentDevice.plant}}</p>
                  </div>
                </li>

                <li v-if="currentDevice.line !== ''">
                  <div class="flex items-center">
                    <!-- Heroicon name: solid/chevron-right -->
                    <svg v-if="currentDevice.plant !== ''" class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <p href="#" class="ml-2 text-sm font-medium text-gray-500 hover:text-gray-700">{{currentDevice.line}}</p>
                  </div>
                </li>

                <li>
                  <div class="flex items-center">
                    <!-- Heroicon name: solid/chevron-right -->
                    <svg v-if="currentDevice.line !== ''" class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                    <p class="ml-2 text-sm font-medium text-gray-500 hover:text-gray-700" aria-current="page">{{currentDevice.name}}</p>
                  </div>
                </li>
              </ol>
            </nav>

          </div>
          <div class="p-2">
            <production-chart :devid="currentDevice.devid || parseInt(this.$route.params.devid)" />
          </div>
        </div>
        <!-- Card -->
        <div class="bg-white overflow-hidden shadow rounded-lg col-span-1">
          <div class="p-2">
            <device-stats v-on:change-product="toggleChangeProduct" :devid="currentDevice.devid || parseInt(this.$route.params.devid)" :modal="changeproductmodal"/>
          </div>
        </div>
      </div>
      <data-table v-on:item-dblclick="(row) => assignDetention(row)" :headers="headers" :rows="rows" :actions="actions" class="shadow" />
    </div>
  </div>
  <template v-for="dynamicform in dynamicforms" >
    <dynamic-form
      :key="dynamicform.blueprintName"
      v-on:toggle-form="dynamicToggleFunc(dynamicform.toggleFunc)"
      v-if="$data[dynamicform.toggleName]"
      :formtype="dynamicform.blueprintName"
      :params="$data[dynamicform.paramsName]"
    />
  </template>
</div>
</template>

<script>
import SidePanel from '@/components/SidePanel'
import ProductionChart from '@/components/ProductionChart'
import DataTable from '@/components/DataTable/DataTable'
import DeviceStats from '@/components/DeviceStats'
import DynamicForm from '@/components/DynamicForm/DynamicForm'
import RangeSelector from '@/components/RangeSelector'
import { getUnixTime } from 'date-fns'

export default {
  name: 'device',
  components: { SidePanel, RangeSelector, ProductionChart, DataTable, DeviceStats, DynamicForm },
  data() {
    return {
      changeproductmodal: false,
      params: {},
      headers: [],
      rows: [],
      actions: [
        {
          header: this.$t('message.device.acciones'),
          text: this.$t('message.device.dividirdetencion'),
          method: this.splitDetention
        }
      ],
      detention: {},
      detentionassignmodal: false,
      splitdetentionmodal: false,
      dynamicforms: []
    }
  },
  created() {
    this.fetchDetentions(),
    this.getDynamicForm()
  },
  computed: {
    currentDevice(){
      return this.$store.getters.currentDevice
    },
    range() {
      return { start: this.$store.getters.innerStart, end: this.$store.getters.innerEnd }
    },
  },
  watch: {
    currentDevice() {
      this.params = {devid: this.currentDevice.devid}
      this.fetchDetentions()
    },
    range() {
      this.fetchDetentions()
    }
  },
  methods: {
    async getDynamicForm(){
      const response = await this.$http.get(`/forms?form=dynamicforms_deviceview`)
      this.dynamicforms = response.data
    },
    dynamicToggleFunc(funcInStr){
      return this[funcInStr]()
    },
    toggleChangeProduct() {
      this.params = {devid: this.currentDevice.devid}
      this.changeproductmodal = !this.changeproductmodal
    },
    async fetchDetentions() {
      let start = getUnixTime(this.range.start)
      let end = getUnixTime(this.range.end)
      const response = await this.$http.get(`/detentions?devid=${this.currentDevice.devid}&start=${start}&end=${end}`)
      this.rows = response.data.detentions
      const headers = await this.$http.get(`/tables?table=detentions`)
      this.headers = headers.data
    },
    assignDetention(detention) {
      this.detention = detention
      this.detentionassignmodal = true
    },
    toggleDetentionAssign() {
      this.detentionassignmodal = !this.detentionassignmodal
      this.fetchDetentions()
    },
    splitDetention(detention){
      this.detention = detention;
      this.splitdetentionmodal = true;
    },
    toggleSplitDetention(){
      this.splitdetentionmodal = !this.splitdetentionmodal;
      this.fetchDetentions();
    }
  },
}
</script>
